import React from 'react';
import {
  Dialog,
  Table,
  TableHead,
  TableRow,
  Typography,
  TableCell,
  TableBody,
  Button,
} from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import { groupMaterialsByName } from '../../helperFunctions';
import useWindowDimensions from '../../hooks/useWindowDimensions';
import { setUsedMaterialsDialog } from '../redux';

export default () => {
  const dispatch = useDispatch();
  const { width } = useWindowDimensions();
  const usedMaterialsDialog = useSelector(state => state.tasks.usedMaterialsDialog);
  const data = useSelector(state => state.tasks.data);
  const { usedMaterials } = data;
  const fontSize = width <= 500 ? '4vw' : '20px';

  return (
    <Dialog open={usedMaterialsDialog.open} fullScreen>
      <Button
        onClick={() => dispatch(setUsedMaterialsDialog({ open: false }))}
        variant="contained"
        style={{ width: '100%', margin: '4px' }}
      >
        <Typography gutterBottom component="span" style={{ fontSize }}>
          Затвори
        </Typography>
      </Button>
      <div style={{ backgroundColor: '#da291c', padding: '3px' }}>
        <Typography
          gutterBottom
          component="span"
          style={{ fontSize, color: 'white', padding: '1px' }}
        >
          По адреси
        </Typography>
      </div>
      {usedMaterials && (
        <>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell style={{ fontSize }} size="small">
                  Име
                </TableCell>
                <TableCell style={{ fontSize }} size="small">
                  Сер. номер
                </TableCell>
                <TableCell style={{ fontSize }} size="small">
                  Адрес
                </TableCell>
                <TableCell style={{ fontSize }} size="small">
                  Кол.
                </TableCell>
                <TableCell style={{ fontSize }} size="small" />
              </TableRow>
            </TableHead>
            <TableBody>
              {usedMaterials.map(x => (
                <TableRow key={x.serialNumber}>
                  <TableCell style={{ fontSize }} size="small">
                    {x.materialName}
                  </TableCell>
                  <TableCell style={{ fontSize }} size="small">
                    {x.serialNumber}
                  </TableCell>
                  <TableCell style={{ fontSize }} size="small">
                    {x.taskAddress}
                  </TableCell>
                  <TableCell style={{ fontSize }} size="small">
                    {x.quantity}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
          <div style={{ backgroundColor: '#da291c', padding: '3px', marginTop: '3px' }}>
            <Typography
              gutterBottom
              component="span"
              style={{ fontSize, color: 'white', padding: '1px' }}
            >
              Общо
            </Typography>
          </div>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell style={{ fontSize }} size="small">
                  Име
                </TableCell>
                <TableCell style={{ fontSize }} size="small">
                  Кол.
                </TableCell>
                <TableCell style={{ fontSize }} size="small" />
              </TableRow>
            </TableHead>
            <TableBody>
              {groupMaterialsByName(usedMaterials).map(x => {
                const keys = Object.keys(x);
                return (
                  <TableRow key={keys[0]}>
                    <TableCell style={{ fontSize }} size="small">
                      {keys[0]}
                    </TableCell>
                    <TableCell style={{ fontSize }} size="small">
                      {x[keys[0]]}
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </>
      )}
    </Dialog>
  );
};
